<template>
  <div class="top-bar">
    <div class="left-head">
      <div class="logo"></div>
      <div class="title-area">
        <div class="title font-source-han-srif-heavy">{{ library.name }}</div>
        <div class="sub-title font-source-han-srif-heavy">
          <span style="visibility: hidden;">HUNANZHONGYIYAODAXUESHUZIHUATUSHUGUAN</span> <span class="inline-sub" style="visibility: hidden;">HUXIANGZHONGYIGUJISHUJUKU</span>
        </div>
      </div>
    </div>
    <div class="right-head">
      <div class="btn-group" v-show="!$isPhone">
        <div class="btn" :class="{ active: curActive === 'home' }" @click="navTo('home')">首页</div>
        <div class="btn" :class="{ active: curActive === 'literature' }" @click="navTo('literature')">文献</div>
      </div>
      <div class="translate" :class="{ active: isTra }" @click="lanToggle"></div>
    </div>
    <login ref="login" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import login from '@/components/login'
import translate from '@/utils/translate'
export default {
  data () {
    return {
      height: window.innerHeight / 1080,
      title: '湖南中醫藥大學數字化圖書館——湖湘中醫古籍数據庫'
    }
  },
  components: {
    login
  },
  computed: {
    curActive () {
      return this.$route.name
    },
    ...mapGetters(['contentLists', 'isTra', 'userInfo', 'library'])
  },
  methods: {
    navTo (key) {
      this.$router.push({ name: key })
    },
    openLogin () {
      this.$refs.login.open()
    },
    navLocal (key) {
      this.$nextTick(() => {
        this.$refs.dropdown.hide()
      })
    },
    lanToggle () {
      this.$store.commit('toggleIsTra')
      this.enCoding()
    },
    enCoding () {
      let obj = document.getElementById('app')
      translate(obj, this.isTra)
    },
    logOut () {
      this.$store.dispatch('logOut').then(() => {
        this.$router.push('/home')
      })
    }
  },
  mounted () {
    // // 根据url_config设置标题
    // let path = window.location.origin + window.location.pathname
    // for (let key in window.url_config) {
    //      if (path.includes(key)) {
    //        this.title = window.url_config[key].title
    //      }
    // }
    this.enCoding()
  },
  watch: {
    $route () {
      setTimeout(() => {
        this.enCoding()
      }, 50)
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/variables.less";
// @media screen and (min-width: 769px) {
  .top-bar {
    width: 1920px;
    height: 84px;
    background: #7c1823;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    .left-head {
      display: flex;
      align-items: center;
      margin-left: 23px;
      .logo {
        width: 72px;
        height: 52px;
        background-image: url("~@/assets/images/logo.png");
        background-size: 100% 100%;
      }
      .title-area {
        margin-left: 10px;
        color: #f5f2eb;
      }
      .title {
        font-size: 2.4rem;
      }
      .sub-title {
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 0.38rem;
        .inline-sub {
          display: inline-block;
          margin-left: 73px;
        }
      }
    }
    .right-head {
      display: flex;
      align-items: center;
      margin-right: 64px;
    }
    .btn-group {
      display: flex;
      width: 180px;
      justify-content: space-between;
      .btn {
        padding: 4px 22px;
        .font-size-medium;
        // height: 34px;
        color: white;
        cursor: pointer;
        font-weight: bold;
        border-radius: 4px;
        transition: color 0.5s;
        transition: background-color 0.5s;
        &:hover,
        &.active {
          background-color: white;
          color: #7c1823;
        }
      }
    }
    .translate {
      width: 43px;
      height: 40px;
      background-image: url("~@/assets/images/translate.png");
      background-size: 100% 100%;
      margin: 0 48px;
      cursor: pointer;
      &.active {
        background-image: url("~@/assets/images/translate-active.png");
      }
    }
    .user {
      /deep/ .el-avatar {
        background-color: #7a7374;
        color: white;
      }
      /deep/ .el-avatar--circle {
        // border-radius: 0%;
      }
    }
  }
// }
// @media screen and (max-width: 768px) {
//   .top-bar {
//     width: 1080px;
//     height: 160px;
//     background-color: rgba(255, 255, 255, 0.8);
//     box-shadow: 0px 7px 10px rgba(158, 136, 113, 0.3);
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     position: absolute;
//     .left-head {
//       display: flex;
//       align-items: center;
//       margin-left: 53px;
//       .title-area {
//         color: #7c1823;
//       }
//       .title {
//         font-size: 57px;
//       }
//       .sub-title {
//         .font-size-small;
//         font-weight: bold;
//         letter-spacing: 11px;
//       }
//     }
//     .right-head {
//       display: flex;
//       align-items: center;
//       margin-right: 45px;
//     }
//     .translate {
//       width: 96px;
//       height: 96px;
//       background-image: url("~@/assets/images/translate-m.png");
//       background-size: 100% 100%;
//       margin: 0 48px;
//       cursor: pointer;
//       &.active {
//         background-image: url("~@/assets/images/translate-m-active.png");
//       }
//     }
//     .nav {
//       width: 99px;
//       height: 71px;
//       background-image: url("~@/assets/images/top-nav.png");
//       background-size: 100% 100%;
//       cursor: pointer;
//     }
//   }
// }
</style>
